const pendingAudioUploads = new Map<string, File>();

export function setPendingAudioUpload(clientId: string, file: File): void {
  pendingAudioUploads.set(clientId, file);
}

export function getPendingAudioUpload(clientId: string): File | null {
  return pendingAudioUploads.get(clientId) ?? null;
}

export function removePendingAudioUpload(clientId: string): void {
  pendingAudioUploads.delete(clientId);
}
